'use es6';

import { BaseResponsiveToolbar, buildActionsForModuleInDndArea } from './BaseResponsiveToolbar';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileModuleToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 */
const MockResponsiveDesktopModuleToolbarToMeasure = ({
  responsiveSize
}) => {
  if (window.SELENIUM_IS_RUNNING) {
    console.warn(`Rendered MockResponsiveDesktopModuleToolbarToMeasure, with responsiveSize: ${responsiveSize}`);
  }
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({}),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isAdvancedModuleWithoutAccess (required)
 */
const MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isAdvancedModuleWithoutAccess (required)
 */
const MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess,
      moduleType: 'rich_text'
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isAdvancedModuleWithoutAccess (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 */
const MockResponsiveMobileModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess,
  isInNonDefaultBreakpointMode = true
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess,
      isInNonDefaultBreakpointMode,
      moduleType: undefined
    }),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveMobileModuleToolbarToMeasure, MockResponsiveDesktopModuleToolbarToMeasure, MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure, MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure, MockResponsiveMobileModuleWithoutAccessToolbarToMeasure };